module.exports = __webpack_public_path__ + "static/media/view-eye.51ab3eab.svg";